export default __webpack_public_path__ + "static/media/info-circle.ffcbdc2a.svg";